import { render, staticRenderFns } from "./RewardsStatus.vue?vue&type=template&id=4e64f95a&scoped=true&"
import script from "./RewardsStatus.vue?vue&type=script&lang=js&"
export * from "./RewardsStatus.vue?vue&type=script&lang=js&"
import style0 from "./RewardsStatus.vue?vue&type=style&index=0&id=4e64f95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e64f95a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
